export default {"src":"/_next/static/image/public/images/ic_chat_blue.0f2d5dabfe37ca60832ef35e145be582.svg","height":40,"width":40};